// extracted by mini-css-extract-plugin
module.exports = {"promoInfo":"c6e8ba5398--promoInfo--2hzoj","promoInfo-text":"c6e8ba5398--promoInfo-text--fYvQy","promoSaleInfo":"c6e8ba5398--promoSaleInfo--25kgv"};